<div class="flex-col view-endpoints-wrapper h-100-percent">
  <app-sidenav-header [title]="title" [subtitle]="instanceName"></app-sidenav-header>
  <div class="toast-container mb-12">
    <div @toastMessage *ngIf="showCopiedToast"
         class="flex flex-row justify-between toast-message toast-success">
      <div class="flex flex-row ml-12">
        <div class="icon-wrapper mr-16">
          <mat-icon svgIcon="done"></mat-icon>
        </div>
        <span>{{'VIEW_ENDPOINTS.COPIED' | transloco}}</span>
      </div>
      <mat-icon svgIcon="close" class="mr-18" (click)="closeToast()"></mat-icon>
    </div>
  </div>
  <div class="overflow-y-auto pl-8 pt-8 pr-8 ml--8 mr--8">
    <div *ngIf="arrangedEndpoints.length > 0 ; else endpointsNotAvailable" class="endpoint-outer-container">
      <div class="p-16">
        <ng-container *ngFor="let endpoint of arrangedEndpoints">
          <app-endpoint-row [showCopyUrl]="true" [endpoint]="endpoint">
          </app-endpoint-row>
          <div class="border ml-12 mr-12"></div>
        </ng-container>
      </div>
    </div>
  
    <ng-template #endpointsNotAvailable>
      <div class="flex flex-col items-center mb-20 mt-64">
        <mat-icon svgIcon="desktop_access_disabled" class="no-release-color icon-lg mr-12"></mat-icon>
        <div class="mat-subtitle-1 fw-700 mt-42 fs-28">{{'BLUEPRINT_SUMMARY.ERROR.ENDPOINTS_NOT_AVAILABLE' |
          transloco}}</div>
      </div>
    </ng-template>
  
  </div>
</div>
